<template>
  <span class="icon-Btn" @click="$router.go(-1)">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="ic_back" transform="translate(-11 -50)">
        <g id="arrow-w" transform="translate(11 50)">
          <path
            id="Path_15"
            data-name="Path 15"
            d="M0,0H24V24H0Z"
            fill="none"
          />
          <path
            id="Path_16"
            data-name="Path 16"
            d="M20,11H7.83l5.59-5.59L12,4,4,12l8,8,1.41-1.41L7.83,13H20Z"
          />
        </g>
      </g>
    </svg>
  </span>
</template>
<script>
export default {
  name: "backIcon",
};
</script>
